import BillCreate from "./BillCreate/BillCreate"
import BillDetails from "./BillDetails/BillDetails"
import BillEdit from "./BillEdit/BillEdit"
import BillList from "./BillList/BillList"
import BillPublicDetails from "./BillPublicDetails/BillPublicDetails"

const List = BillList
const Create = BillCreate
const Edit = BillEdit
const Details = BillDetails
const PublicDetails = BillPublicDetails

export default {
    List,
    Create,
    Edit,
    Details,
    PublicDetails,
}
